import React from "react";
export default function MobileAnyx() {
  return (
    <>
      <section className="mobile-anyx-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="mobile-anyx-firstbox">
                <img src="/assets/images/mobile-anyx-firstbox-img1.webp" alt="Mobile Anyx" />
                <span>Mobile and distributed workforces are the new normal</span>
                <p>Mobile and distributed work models are no longer temporary shifts, they are now a fundamental part of how businesses operate. Teams today rely on flexible work environments, digital tools, real-time access to information to stay productive and competitive.</p>
                <p>As organizations embrace remote, hybrid, on-the-go work models, the need for secure, accessible, efficient document management becomes critical. Traditional systems are no longer enough to support teams working across locations, devices, time zones.</p>
                <p>Dox and Box enables businesses to seamlessly adapt to this new reality by providing a centralized, cloud-based platform that ensures continuous access to documents, streamlined workflows, secure collaboration, no matter where work happens.</p>
                <img src="/assets/images/mobile-anyx-firstbox-img2.webp" alt="Mobile Anyx" />
              </div>
            </div>

            <div className="col-lg-8 col-md-8">
              <div className="mobile-anyx-secondbox">
                <h3 className="heading">Built for the ‘Work-from-Anywhere’ Workforce</h3>
                <p>Today’s teams are no longer tied to desks or office locations. Dox and Box empowers mobile and distributed teams to stay productive, connected, in control, no matter where work happens.</p>
                <p>For example:</p>

                <ul>
                  <li><b>Start Workflows on the Go:</b> Capture documents instantly and initiate workflows with automatically organized data.</li>
                  <li><b>Collaborate in Real Time:</b> Share files, route approvals, access information seamlessly, keeping processes moving without delays.</li>
                  <li><b>Complete Tasks Faster:</b> Review, approve, make decisions instantly, ensuring productivity is never interrupted.</li>
                </ul>

                <p>Your team’s best work doesn’t have to happen inside an office. Dox and Box empowers mobile and distributed teams to stay productive wherever they are, enabling seamless document access, real-time collaboration, uninterrupted workflows across locations.</p>

                <div className="mobile-anyx-innerbox">

                  <div className="mobile-anyx-imgbox">
                    <img src="/assets/images/mobile-anyx-icon-1.webp" alt="Mobile Anyx" />
                    <div>
                      <span>Anytime</span>
                      <p>Keep operations running smoothly across time zones and schedules with uninterrupted access to documents and workflows.</p>
                    </div>
                  </div>

                  <div className="mobile-anyx-imgbox">
                    <img src="/assets/images/mobile-anyx-icon-2.webp" alt="Mobile Anyx" />
                    <div >
                      <span>Anywhere</span>
                      <p>Whether in the office, at home, or on the move, stay connected and productive with secure access to your business data</p>
                    </div>
                  </div>

                  <div className="mobile-anyx-imgbox">
                    <img src="/assets/images/mobile-anyx-icon-3.webp" alt="Mobile Anyx" />
                    <div >
                      <span>Any Device</span>
                      <p>Access documents and workflows effortlessly across smartphones, tablets, laptops, without compatibility barriers.</p>
                    </div>
                  </div>

                  <div className="mobile-anyx-imgbox">
                    <img src="/assets/images/mobile-anyx-icon-4.webp" alt="Mobile Anyx" />
                    <div>
                      <span>Cloud-Powered Collaboration</span>
                      <p>With secure, browser-based access and cloud infrastructure, your teams stay synchronized in real time, ensuring consistency, visibility, efficiency across all locations.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}